import React from 'react'
import Header from '../../../components/Dashboard/Header'
import Profilecard from '../../../components/Dashboard/Sponsor/profile/Profilecard'

function SpoProfile() {
  return (
    <div className='overflow-x-hidden  min-h-screen relative bg-[#F3F4FF]'>
      <Header />
        <Profilecard />
        
      </div>
  )
}

export default SpoProfile